// src/store/slices/socialLinkSlice.ts
import { createGenericSlice } from './genericSliceFactory';
import type { SocialLink } from '@/types';

const socialLinkSlice = createGenericSlice<SocialLink>({
    name: 'socialLinks',
    endpoint: '/social-links',
});

export const {
    setCurrentItem: setCurrentSocialLink,
    clearError,
    setSelectedIds,
    toggleSelectId,
    clearSelectedIds,
} = socialLinkSlice.actions;

export const {
    fetchActive: fetchActiveSocialLinks,
} = socialLinkSlice.thunks;

export default socialLinkSlice.reducer;
